<template>
  <a-spin :tip="loadingTip" :spinning="isloading" class="cmswrapper">
    <div>
      <div>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="考试名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入考试名称"
              v-decorator="[
          'testName',
          {rules: [{ required: true, message: '请输入考试名称!' }],initialValue:info.testName}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="题目数量" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入题目数量"
              v-decorator="[
          'questionsCount',
          {rules: [{ required: true, message: '请输入题目数量!' }],initialValue:info.questionsCount}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="考试人数" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入考试人数"
              v-decorator="[
          'examPeople',
          {rules: [{ required: false, message: '请输入考试人数!' }],initialValue:info.examPeople}
        ]"
            ></a-input>
          </a-form-item>
          <!-- <a-form-item label="关联课程" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-row>
                <a-button type="primary" size="small" @click="selCourse">选择课程</a-button>
            </a-row>
            
            <a-tag closable  
            :key="course.id"
            v-for="course in courses"
            @close="() => detachCourse(course.id)"
            >
            {{course.name}}
            </a-tag>
            
          </a-form-item> -->
          <a-form-item label="时间限制" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input-number
              placeholder="请输入"
              v-decorator="[
          'minute',
          {rules: [{ required: true, message: '请输入时间限制!' }],initialValue:info.minute}
        ]"
            />分钟
          </a-form-item>
          <a-form-item label="允许考试次数" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input-number
              placeholder="请输入"
              v-decorator="[
          'frequency',
          {rules: [{ required: true, message: '请输入允许考试次数!' }],initialValue:info.frequency}
        ]"
            />次
          </a-form-item>
          <a-form-item label="及格分数线" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input-number
              placeholder="请输入"
              v-decorator="[ 
          'passLine',
          {rules: [{ required: true, message: '请输入及格分数线!' }],initialValue:info.passLine}
        ]"
            />
          </a-form-item>

          <a-form-item label="考试说明" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-textarea
              placeholder="请输入考试说明"
              v-decorator="[
          'testDescription',
          {rules: [{ required: false, message: '请输入考试说明!' }],initialValue:info.testDescription}
        ]"
              :rows="4"
            />
          </a-form-item>
          <a-form-item label="状态" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-select
              placeholder="请选择状态"
              v-decorator="[
          'examStatus',
          {rules: [{ required: false, message: '请选择状态!' }],initialValue:info.examStatus}
        ]"
            >
              <a-select-option
                :value="info.value"
                v-for="(info, index) in status"
                :key="index"
              >{{info.title}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" style="margin-left:10px;" />
          </a-form-item>
        </a-form>
      </div>
    </div>
    <a-modal
          title="选择课程"
          v-model="selcourse.visible"
          width="80%"
          :footer="false"
          destroyOnClose
          :maskClosable="false"
        >
          <rebroadcastsel :courses="selcourse.courses" @callbackMethod="showCourse" />
        </a-modal>
  </a-spin>
</template>

<script>
import rebroadcastsel from './rebroadcastsel.vue'
var that;

export default {
  props: {
    id: Number,
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        categoryId: [0],
        examStatus:0
      },
      selcourse:{
        visible:false,
        courses:[]
      },
      courses:[],
      treeData: [],
      isloading: false,
      loadingTip: "加载中...",
      status: [{value:0,title:'未发布'},{value:1,title:'进行中'},{value:2,title:'已结束'}]
    };
  },
  components:{
    rebroadcastsel
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      if (this.infos.id) {
        //编辑
        this.getInfo();
      }
      
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    selCourse(){
      this.selcourse.visible=true;
      this.selcourse.courses=this.courses;
    },
    showCourse(){
      this.selcourse.visible=false;
       if(arguments.length>0){
        this.courses=arguments[0];
       }
    },
    detachCourse(id){
      for(var index in this.courses){
        if(this.courses[index].id==id){
          this.courses.splice(index,1);
        }
      }
    },
    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.examination
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data.exam;
            if(res.data.courses){
              res.data.courses.forEach(function(item,index){
                  that.courses.push({
                    id:item.id,
                    name:item.name
                  })
                }
              )
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // if(this.courses.length==0){
          //   this.error("请选择课程");
          //   return;
          // }
          var courseIds=[];
          this.courses.forEach(function(item,index){
            courseIds.push(item.id);
          });
          if (this.infos.id) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.examination
              .updateById(
                this.infos.id,
                values.testName,
                values.questionsCount,
                values.examPeople ? values.examPeople : "",
                values.testDescription ? values.testDescription : "",
                values.minute,
                values.frequency,
                values.passLine,
                values.examStatus,
                "",
                courseIds.join(",")
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                   this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //添加
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.examination
              .save(
                values.testName,
                values.questionsCount,
                values.examPeople ? values.examPeople : "",
                values.testDescription ? values.testDescription : "",
                values.minute,
                values.frequency,
                values.passLine,
                values.examStatus,
                "",
                courseIds.join(",")
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod",res.data);
                } else {
                   this.$message.error(res.errorMsg);
                  
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    onChange() {
      //console.log(date, dateString);
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.ant-cascader-menu {
  height: 320px;
}
</style>